import IconTile from "@/components/common/iconTile/iconTile.component";
import type { LucideIcon } from "lucide-react";

export interface GameUseCase {
  icon: LucideIcon;
  // Small uppercase label over the title ("Festival weeks").
  eyebrow: string;
  title: string;
  text: string;
}

interface GameUseCasesProps {
  cards: GameUseCase[];
}

// "Why shops use it" cards on the game pages: icon tile, eyebrow, title and
// a short line of copy. Four across on desktop, two on tablets, one on phones.
const GameUseCases = ({ cards }: GameUseCasesProps) => (
  <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
    {cards.map((card, index) => (
      <article
        key={card.title}
        className="grid content-start gap-1.5 rounded-[22px] bg-white p-5 shadow-card"
      >
        <IconTile icon={card.icon} index={index} />
        <span className="mt-1 text-[11.5px] font-extrabold tracking-[0.07em] text-ink-muted uppercase">
          {card.eyebrow}
        </span>
        <h3 className="text-[1.15rem] font-bold">{card.title}</h3>
        <p className="text-[15px] leading-normal text-ink-muted">{card.text}</p>
      </article>
    ))}
  </div>
);

export default GameUseCases;
